import { GetStaticProps } from 'next';
import Link from 'next/link';

import BlogArticle from '../../../components/blog/BlogArticle';
import { getBlogPost } from '../../../content/blog/posts';
import { DefaultLocale } from '../../../providers/tolgee';

const Post46PercentCaaspGrowthCa = () => {
  const post = getBlogPost('46-percent-caasp-growth-ca');
  return (
    <BlogArticle post={post}>
      <figure>
        <img
          src="/blog/46-percent-caasp-growth-ca/inline-1.png"
          alt={
            'Impact at a glance: students above or near standard rose from 50 percent in 2022-2023 without Curipod to 73 percent in 2023-2024 with Curipod.'
          }
        />
      </figure>
      <p>
        {
          'Over the years, a group of veteran teachers in Southern California routinely saw the latest and greatest EdTech sweep through the district, but they just didn’t see the value in most tools. Then they saw a Curipod lesson. Once they experienced the authentic '
        }
        <Link
          href="/c/blog-posts/beyond-the-ela-classroom-how-to-improve-writing-instruction-across-the-curriculum"
          passHref
        >
          <a>{'writing practice'}</a>
        </Link>
        {', immediate AI Feedback, and tangible impact on '}
        <Link href="/c/blogs" passHref>
          <a>{'student engagement'}</a>
        </Link>
        {'—plus, rising '}
        <Link
          href="/c/blog-posts/from-test-prep-to-lasting-learning-how-to-raise-standardized-test-scores-without-burning-out-teachers-or-students"
          passHref
        >
          <a>{'test scores'}</a>
        </Link>
        {'—they were all in.'}
      </p>
      <blockquote>
        {
          '“In over 15 years as a tech trainer, I don’t know that I’ve seen a teacher site catch on as quickly for a wide range of tech abilities as Curipod,” the district’s Technology Training Specialist shared.'
        }
      </blockquote>
      <p>
        {
          'For about a month before state testing, upper elementary teachers added Curipod’s AI-powered targeted writing practice and CAASPP Test Prep lessons into their routines. This wasn’t a year-long test prep boot camp; just highly-effective and engaging practice.'
        }
      </p>
      <blockquote>
        {
          '“The students are engaged and are often asking to do more,” the tech coach said.'
        }
      </blockquote>
      <h2>{'Curipod made a difference in 3 ways:'}</h2>
      <h3>{'Targeted, Engaging Writing Practice:'}</h3>
      <p>
        {
          'Students respond to standards-aligned prompts modeled after CAASPP. Powered by AI, they practice rigorous grade-level skills on topics they care about, like supporting claims with evidence about Taylor Swift or the World Cup.'
        }
      </p>
      <h3>{'Immediate AI Feedback:'}</h3>
      <p>
        {
          'With Curipod, students get personalized feedback from AI instantly. Then, they have the chance to revise and improve their scores in real time.'
        }
      </p>
      <h3>{'Authentic Learning Community:'}</h3>
      <p>
        {
          'What was once a solitary task becomes a social one. Writing becomes a shared experience, where students discuss their feedback and celebrate growth together.'
        }
      </p>
      <p>
        {
          'From the month of using Curipod, teachers saw a leap in writing achievement: 73% of students scored Near or Above Standard, a growth of 23 percentage points. Of those students, 13.5% scored Above Standard, a growth of 8.5 percentage points from the year before. At the same time, the number of students below standard dropped from 50% to just 27%.'
        }
      </p>
      <p>{'Curipod was helping to raise achievement and close the gaps.'}</p>
      <figure>
        <img
          src="/blog/46-percent-caasp-growth-ca/inline-2.png"
          alt={
            'CAASPP results from 5th grade 2022-2023 to 6th grade 2023-2024: above standard 5 percent to 13.5 percent, near standard 45 percent to 59.5 percent, below standard 50 percent to 27 percent.'
          }
        />
      </figure>
      <blockquote>
        {
          '“Yes, those teachers worked hard,” their tech coach said, “but they also attribute the growth to using Curipod.”'
        }
      </blockquote>
      <p>
        {
          'The teachers saw firsthand the power of AI in closing the feedback loop, which research shows is oneof the most effective ways to drive outcomes. Even experienced teachers face the demands of the job,particularly around providing timely feedback on writing. One teacher shared that students were usedto waiting a week or more for feedback. Curipod helps teachers achieve the impossible: provide personalized feedback to every student before the bell rings.'
        }
      </p>
      <p>
        {
          'What’s even more notable is that these educators weren’t tech-heavy users. In fact, the upperelementary teachers had little experience with EdTech tools. But Curipod’s simple, visual designmade it easy to get started.'
        }
      </p>
      <blockquote>
        {
          '“The teachers who never reach out to us are asking about Curipod,” the tech coach went on to say. “Once they try it, they come back and tell us, ‘It’s so easy!’”'
        }
      </blockquote>
      <p>
        {
          'Built on research-backed best practices for student engagement and learning, Curipod uses interactive tools and artificial intelligence to help teachers provide instruction that authentically engages students in learning.'
        }
      </p>
      <p>
        {
          'When students get more chances to write in ways they care about, and when teachers have the tools to empower student ownership, achievement soars.'
        }
      </p>
    </BlogArticle>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default Post46PercentCaaspGrowthCa;
